import { NgModule } from '@angular/core';

import {
  CurrencyPipe,
  CreditCardNumberPipe,
  TruncatePipe,
  DatePipe,
  FirstLetters,
  FilterPipe,
  FileSizePipe,
  SafePipe,
  PolicyStepPipe,
  CategoryImagesPipe,
  VisualizacionImagesPipe,
  PrefixPipe,
  ReversePipe,
  SideBarLinkPipe,
  BranchDescriptionPipe,
  DynamoRiskCleanupPipe,
  ProducerCodePipe,
  CurrencyWithDecimalsPipe
} from './';
import { UpperCasePipe } from './upper-case.pipe';
import { TextFormatterPipe } from './text-formatter.pipe';
import { PolicyNumberPipe } from './policy-number.pipe';
import { DniPipe } from './dni.pipe';
import { CuitPipe } from './cuit.pipe';
import { OrderByPipe } from './order-by.pipe';
import { HTMLSanitizerPipe } from './html-sanitizer.pipe';
import { MainCoveragesPipe } from './main-coverages.pipe';
import { RegularCoveragesPipe } from './regular-coverages.pipe';

const pipes = [
  CurrencyPipe,
  DatePipe,
  TruncatePipe,
  FirstLetters,
  FilterPipe,
  PolicyStepPipe,
  CategoryImagesPipe,
  FileSizePipe,
  SafePipe,
  CreditCardNumberPipe,
  VisualizacionImagesPipe,
  PrefixPipe,
  ReversePipe,
  SideBarLinkPipe,
  BranchDescriptionPipe,
  DynamoRiskCleanupPipe,
  DniPipe,
  CuitPipe,
  OrderByPipe,
  ProducerCodePipe,
  UpperCasePipe,
  TextFormatterPipe,
  PolicyNumberPipe,
  HTMLSanitizerPipe,
  CurrencyWithDecimalsPipe,
  MainCoveragesPipe,
  RegularCoveragesPipe
];

@NgModule({
    declarations: pipes,
    exports: pipes,
    providers: pipes
})
export class PipesModule {
}
